import React from 'react'

import { formatAddress } from 'src/shared/components/common/form_input/LocationInput'
import { LocationWithDistance } from 'src/shared/utils/addressUtils'

export const LocationOptionLabel = ({
  location,
  showDistance,
  locale,
  additionalInfo
}: {
  location: LocationWithDistance
  showDistance: boolean
  locale?: string
  additionalInfo?: React.ReactNode
}) => {
  return (
    <div className='locationLabel'>
      <div className='locationNameContainer'>
        <span className='locationName'>{location.name}</span>
        {showDistance && location.distanceToReference >= 0 && (
          <span className='locationDistance'>
            (
            {new Intl.NumberFormat(locale || 'en-US', {
              style: 'unit',
              unit: location.distanceUnits === 'km' ? 'kilometer' : 'mile',
              unitDisplay: 'long',
              maximumFractionDigits: 2
            }).format(location.distanceToReference)}
            )
          </span>
        )}
      </div>
      <span className='locationAddress'>{formatAddress(location)}</span>
      {additionalInfo}
    </div>
  )
}
